export class PushNotification {
    static cancelLocalNotifications = () => console.log("not available on web")
    static localNotificationSchedule = () => console.log("not available on web")
    static localNotification = () => console.log("not available on web")   
}
